// this is a temporary solution until store the TCPA requirements on the backend
export const integrationsWithTcpa = Object.freeze([
  // zapier in dev
  '1ff4ea97-11d6-4a62-b2db-34a1da933288',
  // zapier in prod
  'e2b43d13-5d3b-4868-8ca2-eeeaa39b9f9c',
])
